import { useInfiniteQuery } from '@tanstack/react-query'
import { PulsePaginatedFilters } from 'api/pulse/types'
import { getTopCompliments, TopCompliments } from 'api/pulse/topCompliments'
import { getTopComplimentsKey } from 'queries/pulse/keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useTopCompliments(query: PulsePaginatedFilters) {
  return useInfiniteQuery<TopCompliments>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getTopComplimentsKey(query),
    queryFn: async ({ pageParam = 0, signal }) => {
      const start = (pageParam as number) * query.pageSize
      const fetchedData = await getTopCompliments(
        {
          ...query,
          page: start,
        },
        signal
      )
      return fetchedData
    },
    enabled: !!query.companyIds?.length,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      !lastPage.length || lastPage.length < query.pageSize
        ? undefined
        : allPages.length,
  })
}
